import type { PathLookupDecisionEvent } from '@ipfabric/utils';
import { isSeverityEvent } from './isSeverityEvent';

export const hasEventFilterData = (event: PathLookupDecisionEvent): boolean =>
  event.type === 'table entry match' ||
  event.type === 'packet data match' ||
  event.type === 'table entry not found' ||
  event.type === 'route detail' ||
  isSeverityEvent(event);

export const hasDecisionCellValue = (event: PathLookupDecisionEvent): boolean =>
  (event.type === 'remove header' && !!event.reason) ||
  hasEventFilterData(event);
